import { EventStatus } from "../../redux/features/event/event.types";

export const EmptyEventState = ({
  eventStatus = "upcoming",
}: {
  eventStatus?: EventStatus;
}) => {
  return (
    <div className="flex w-full flex-col items-center justify-center gap-4 rounded-2xl bg-white px-3 py-12 text-center">
      <img
        alt="calendar"
        src="/assets/images/calendar.png"
        className="h-[120px] w-[120px]"
      />

      <p className="text-32 max-w-[320px] font-fraunces font-medium capitalize">
        No {eventStatus === "completed" ? "Past" : eventStatus} Events
      </p>

      <p className="max-w-[320px] text-base text-grey-600">
        All your {eventStatus} events would show here
      </p>
    </div>
  );
};
